import { pdfjs } from 'react-pdf';

let configured = false;

/**
 * Idempotently configure the PDF.js worker.
 *
 * The worker must match react-pdf's bundled pdfjs-dist exactly — a version
 * mismatch surfaces as "The API version does not match the worker version."
 * `npm run copy-pdf-worker` (also runs on postinstall/build) copies
 * `node_modules/pdfjs-dist/build/pdf.worker.min.mjs` to `public/`.
 */
export function configurePdfWorker(): void {
  if (configured) return;
  (pdfjs.GlobalWorkerOptions as { workerSrc: string }).workerSrc =
    `${process.env.PUBLIC_URL ?? ''}/pdf.worker.min.mjs`;
  configured = true;
}
